import { DatatableContextProvider } from "@/components/tables/contexts/DatatableContextProvider";
import { ExplorerContent } from "./ExplorerContent";

export const Explorer = () => (
  <DatatableContextProvider>
    <ExplorerContent />
  </DatatableContextProvider>
);
